import { Component } from "react"
import { Grid } from "@mui/material"
import { Input } from "components/forms/components"
import { Text } from "components/texts"
import { ItemsSelect } from "components/forms/components/Select/custom"

export default class ClasesParticularesColectivosTemplate extends Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)
  }

  /**
   * Render
   *
   * @returns {Component}
   */
  render() {
    const { register, errors } = this.props
    return (
      <>
        <Grid container mt={2} mb={1}>
          <Text fontWeight={"bold"}>Según datos de:</Text>
          <br />
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <ItemsSelect label={"Materia"} name={"actividad_id"} keyValue={"actividad"} register={register} errors={errors} wantToReset={this.props.reset} searcheable />
          </Grid>

          <Grid item xs={4}>
            <ItemsSelect name={"empresa_id"} keyValue={"empresa"} register={register} errors={errors} wantToReset={this.props.reset} searcheable />
          </Grid>

          <Grid item xs={4}>
            <ItemsSelect name={"curso_escolar_id"} keyValue={"curso_escolar"} register={register} errors={errors} wantToReset={this.props.reset} />
          </Grid>
        </Grid>
      </>
    )
  }
}
